export default {
  hasActivity: state => {
    return !!state.activity && !!state.activity.id
  },
  hasSelectedProspect: state => {
    return !!state.selectedProspect && !!state.selectedProspect.name
  },
  hasSelectedOpportunity: state => {
    return !!state.selectedOpportunity && !!state.selectedOpportunity.name
  },
  hasSelectedStage: state => {
    return !!state.selectedStage && !!state.selectedStage.name
  },
  opportunityEnabled: (state, getters) => {
    return getters.hasSelectedProspect && ['account', 'contact'].includes(state.selectedProspect.type)
  },
  stageEnabled: (state, getters) => {
    return getters.hasSelectedOpportunity ||
      (getters.hasSelectedProspect && state.selectedProspect.type === 'lead')
  },
  taskEnabled: (state, getters) => {
    return getters.hasSelectedProspect
  }
}



// WEBPACK FOOTER //
// ./~/vue-components/activity-summary/store/getters.js